
// Vendor
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

// Internal
import { store, StoreMutations, FiltriOrdini, FiltriOrdiniMTM } from '@/store';
import { ItemDatiLookup } from '@/models';

@Component
export default class OpzioniOrdiniMtm extends Vue {

  @Watch("$store.state.ui.opzioniVisibili")
  onOpzioniOpened(isOpenNew: boolean, isOpenOld: any) {
      if(isOpenNew && isOpenNew != isOpenOld) {
          // caricamento filtro corrente
          this.filtroNominativoCliente = store.state.uiOrdiniMTM.filtri.nominativoCliente;
          this.filtroIdCliente = store.state.uiOrdiniMTM.filtri.idCliente;
          this.filtroDataConsegnaA = store.state.uiOrdiniMTM.filtri.dataConsegnaA;
          this.filtroDataConsegnaDa = store.state.uiOrdiniMTM.filtri.dataConsegnaDa;
          this.filtroStato = store.state.uiOrdiniMTM.filtri.stato;
          this.filtroNumeroOrdine = store.state.uiOrdiniMTM.filtri.numeroOrdine;
          this.filtroRigaDataChiusuraConsegnaDa = store.state.uiOrdiniMTM.filtri.rigaDataChiusuraConsegnaDa;
          this.filtroRigaDataChiusuraConsegnaA = store.state.uiOrdiniMTM.filtri.rigaDataChiusuraConsegnaA;
          this.filtroRigaDataConsegnaFornitoreDa = store.state.uiOrdiniMTM.filtri.rigaDataConsegnaFornitoreDa;
          this.filtroRigaDataConsegnaFornitoreA = store.state.uiOrdiniMTM.filtri.rigaDataConsegnaFornitoreA;
          this.filtroModelli = store.state.uiOrdiniMTM.filtri.filtroModelli;
          this.filtroStagioni = store.state.uiOrdiniMTM.filtri.filtroStagioni;
      }
  }
  filtroNominativoCliente: string = "";
  filtroIdCliente: string = "";
  filtroNumeroOrdine: string = "";

  private menu1: boolean = false;
  private menu2: boolean = false;
  private menu3: boolean = false;
  private menu4: boolean = false;
  private menu5: boolean = false;
  private menu6: boolean = false;
  private filtroDataConsegnaDa: string = '';
  private filtroDataConsegnaDaFormatted: string = '';
  private filtroDataConsegnaA: string = '';
  private filtroDataConsegnaAFormatted: string = '';

  private filtroRigaDataConsegnaFornitoreDa: string = '';
  private filtroRigaDataConsegnaFornitoreDaFormatted: string = '';
  private filtroRigaDataConsegnaFornitoreA: string = '';
  private filtroRigaDataConsegnaFornitoreAFormatted: string = '';

  private filtroRigaDataChiusuraConsegnaDa: string = '';
  private filtroRigaDataChiusuraConsegnaDaFormatted: string = '';
  private filtroRigaDataChiusuraConsegnaA: string = '';
  private filtroRigaDataChiusuraConsegnaAFormatted: string = '';

  searchModello: string = '';
  filtroModelli: string[] = [];
  searchStagione: string = '';
  filtroStagioni: string[] = [];

  private filtroStato : any = {
    label:"",
    value: ""
  }
  private opzioniStato= [
    {
      label: "",
      value: ""
    },
    {
      label: "Spedito",
      value: "SPEDITO"
    },
    {
      label: "Ordine inserito",
      value: "ORDINE INSERITO"
    },
    {
      label: "In lavorazione",
      value: "IN LAVORAZIONE"
    },
    {
      label: "Inviato",
      value: "INVIATO"
    },
    {
      label: "Consegna chiusa",
      value: "CONSEGNA CHIUSA"
    }
  ]

  
  get modelliFiltrati(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.modelli) {
      return store.state.datiLookup.modelli.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchModello || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  get stagioniFiltrate(): ItemDatiLookup[] {
    if(store.state.datiLookup && store.state.datiLookup.stagioni) {
      return store.state.datiLookup.stagioni.filter((e:ItemDatiLookup) => (e.desc || '')
        .toLowerCase()
        .indexOf((this.searchStagione || '').toLowerCase()) > -1
      );
    }
    return [];
  }

  private annullaModificaFiltro() {
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private applicaModificaFiltro() {
    const filtri: FiltriOrdiniMTM = {
      nominativoCliente: this.filtroNominativoCliente,
      idCliente: this.filtroIdCliente,
      numeroOrdine: this.filtroNumeroOrdine,
      stato: this.filtroStato,
      dataConsegnaA: this.filtroDataConsegnaA,
      dataConsegnaDa: this.filtroDataConsegnaDa,
      rigaDataChiusuraConsegnaDa: this.filtroRigaDataChiusuraConsegnaDa,
      rigaDataChiusuraConsegnaA: this.filtroRigaDataChiusuraConsegnaA,
      rigaDataConsegnaFornitoreDa: this.filtroRigaDataConsegnaFornitoreDa,
      rigaDataConsegnaFornitoreA: this.filtroRigaDataConsegnaFornitoreA,
      filtroModelli: this.filtroModelli,
      filtroStagioni: this.filtroStagioni,
    };

    store.commit(StoreMutations.SetFiltriOrdiniMTM, filtri);
    store.commit(StoreMutations.SetOpzioniVisibili, false);
  }

  private svuotaFiltro() {
    this.filtroNominativoCliente = '';
    this.filtroNumeroOrdine = '';
    this.filtroStato = '';
    this.filtroDataConsegnaA = '';
    this.filtroDataConsegnaDa = '';
    this.filtroDataConsegnaAFormatted = '';
    this.filtroDataConsegnaDaFormatted = '';
    this.filtroRigaDataChiusuraConsegnaDa = '';
    this.filtroRigaDataChiusuraConsegnaA = '';
    this.filtroRigaDataChiusuraConsegnaDaFormatted = '';
    this.filtroRigaDataChiusuraConsegnaAFormatted = '';
    this.filtroRigaDataConsegnaFornitoreDa = '';
    this.filtroRigaDataConsegnaFornitoreA = '';
    this.filtroRigaDataConsegnaFornitoreDaFormatted = '';
    this.filtroRigaDataConsegnaFornitoreAFormatted = '';
    this.filtroModelli = [];
    this.filtroStagioni = [];
  }

@Watch('filtroDataConsegnaDa')
onDateChange(): void {
    this.filtroDataConsegnaDaFormatted = this.formatDate(this.filtroDataConsegnaDa);
}
@Watch('filtroDataConsegnaA')
onDataAChange(): void {
    this.filtroDataConsegnaAFormatted = this.formatDate(this.filtroDataConsegnaA);
}

@Watch('filtroRigaDataChiusuraConsegnaDa')
onFiltroRigaDataChiusuraConsegnaDaChange(): void {
    this.filtroRigaDataChiusuraConsegnaDaFormatted = this.formatDate(this.filtroRigaDataChiusuraConsegnaDa);
}

@Watch('filtroRigaDataChiusuraConsegnaA')
onFiltroRigaDataChiusuraConsegnaAChange(): void {
    this.filtroRigaDataChiusuraConsegnaAFormatted = this.formatDate(this.filtroRigaDataChiusuraConsegnaA);
}

@Watch('filtroRigaDataConsegnaFornitoreDa')
onFiltroRigaDataConsegnaFornitoreDaChange(): void {
    this.filtroRigaDataConsegnaFornitoreDaFormatted = this.formatDate(this.filtroRigaDataConsegnaFornitoreDa);
}

@Watch('filtroRigaDataConsegnaFornitoreA')
onFiltroRigaDataConsegnaFornitoreAChange(): void {
    this.filtroRigaDataConsegnaFornitoreAFormatted = this.formatDate(this.filtroRigaDataConsegnaFornitoreA);
}

formatIsoDate(date: string): string {
    if (!date) return '';

    return dayjs(date).format('DD/MM/YYYY');
}
formatDate (date: string): string {
    if (!date) return '';

    const [year, month, day] = date.split('-');
    return `${day}/${month}/${year}`;
}

parseDate (date: string): string {
    if (!date) return '';

    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}
}
